import { h } from 'preact';
import classNames from 'classnames';


export default function Tabs(props) {
  const { services, activeService, setActiveService} = props;

  const renderedList = services.map(service => {
    return (
      <button
        type="button"
        key={service.id}
        className={classNames('tabs__item', `tabs__item--${service.id}`,{
          'tabs__item--active': activeService === service.id,
        })}
        onClick={() => {
          setActiveService(service.id)
        }}
      >
        {service.id === 45 && (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M3 6.75H15" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3 11.25H15" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.5 2.25L6 15.75" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 2.25L10.5 15.75" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        )}
        {service.id === 46 && (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M12 13.5L16.5 9L12 4.5" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 4.5L1.5 9L6 13.5" stroke="#37418E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        )}
        <strong>{service.title}</strong>
      </button>
    )
  });
  return (
    <div className="tabs" style={{
      gridTemplateColumns: `repeat(${services.length}, 1fr)`
    }}>
      {services.length > 1 && renderedList}
    </div>
  )
}
